import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./footerSection.css";
import {
  FaFacebookSquare,
  FaLinkedin,
  FaTwitterSquare,
  FaInstagramSquare,
} from "react-icons/fa";

const FooterSection = ({ footerNode }) => {
  return (
    <Box pl={{ xs: 2, sm: 5, md: 15 }} pr={{ xs: 2, sm: 5, md: 15 }}>
      <Grid container spacing={4}>
        <Grid item md={4} sm={4} xs={12}>
          <img src="/ttk_logo.png" className="footerLogo" />
          {footerNode.noteText ? (
            <p className="note">{footerNode.noteText}</p>
          ) : null}
          <Box>
            <FaFacebookSquare className="socialIcon" />
            <FaLinkedin className="socialIcon" />
            <FaTwitterSquare className="socialIcon" />
            <FaInstagramSquare className="socialIcon" />
          </Box>
        </Grid>
        {footerNode.firstTab ? (
          <Grid item md={4} sm={4} xs={12}>
            <p className="itemHead">{footerNode.firstTabTitle}</p>
            <ul className="itemUL">
              {footerNode.firstTabItems.map((item) => {
                return (
                  <li className="itemLI" key={item._key}>
                    <a href={item.itemURL} className="itemA">
                      {item.itemTitle}
                    </a>
                  </li>
                );
              })}
            </ul>
          </Grid>
        ) : null}
        {footerNode.secondTab ? (
          <Grid item md={4} sm={4} xs={12}>
            <p className="itemHead">{footerNode.secondTabTitle}</p>
            <ul className="itemUL">
              {footerNode.secondTabItems.map((item) => {
                return (
                  <li className="itemLI" key={item._key}>
                    <a href={item.itemURL} className="itemA">
                      {item.itemTitle}
                    </a>
                  </li>
                );
              })}
            </ul>
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
};

export default FooterSection;
